module.exports = __webpack_public_path__ + "static/media/twist-logo.0a289e4c.svg";